<footer
    class="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
    <p class="text-muted mb-1 mb-md-0">{{'Footer.Copyright_©_2024' | translate}} <a href="gosmartcrm.com"
            target="_blank">AgentsGO</a>.</p>
    <p class="text-muted">{{'Footer.Handcrafted_With' | translate}} <i
            class="feather icon-heart mb-1 text-primary ms-1 icon-sm"></i></p>
</footer>